module.exports = __webpack_public_path__ + "static/media/clients.c6a2afd7.png";